export default __webpack_public_path__ + "static/media/wellgo_reviewer6.dafdcc95.jpg";